import { IProductDto } from 'api/products/dto';

export type OrderItems = {
  quantity: number;
  price: number;
  name: string;
};

export const transformBasicPackage = (item: IProductDto[]): OrderItems[] => {
  return (
    item.map(product => ({
      quantity: product.quantity ?? 0,
      name: product?.name ?? '',
      price: product.discountedPrice ?? 0,
    })) ?? []
  );
};
